import React from 'react';

export default function NotFound() {
  return (
    <section className="not-found-page">
      <div className="not-found-card section-card">
        <span className="eyebrow">Page Not Found</span>
        <strong className="not-found-code">404</strong>
        <h1>This page does not exist.</h1>
        <p>
          The address may be outdated, unavailable, or typed incorrectly. Return to the storefront and continue browsing.
        </p>
        <a className="not-found-link" href="/">
          Return to homepage
        </a>
      </div>
    </section>
  );
}
